var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pv-overlay",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          _vm.$emit("close")
        }
      }
    },
    [
      _vm.variant === "3"
        ? _c("div", { staticClass: "og-box" }, [
            _c("div", { staticClass: "og-header" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "og-close",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "og-body" }, [
              _c("div", { staticClass: "og-product-chip" }, [
                _vm.product.image
                  ? _c("img", {
                      staticClass: "og-product-thumb",
                      attrs: { src: _vm.product.image, alt: "" }
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "og-product-thumb og-product-thumb--empty"
                      },
                      [_vm._v("📦")]
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "og-product-meta" }, [
                  _c("div", { staticClass: "og-product-name" }, [
                    _vm._v(_vm._s(_vm.sliceName(_vm.product.productName)))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "og-product-asin" }, [
                    _vm._v("ASIN: " + _vm._s(_vm.product.asin))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "og-compare" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "og-compare-arrow" }, [
                  _c(
                    "svg",
                    {
                      attrs: { width: "32", height: "32", viewBox: "0 0 32 32" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M8 16h16m0 0l-6-6m6 6l-6 6",
                          stroke: "#e67e22",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "og-price-row" }, [
                _c("div", { staticClass: "og-price-label" }, [
                  _vm._v("特急チケット")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "og-price-amount" }, [
                  _c("span", { staticClass: "og-price-currency" }, [
                    _vm._v("¥")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "og-price-num" }, [
                    _vm._v(_vm._s(_vm.price.toLocaleString()))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "og-price-tax" }, [
                    _vm._v("（税込）")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "og-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default og-btn-cancel",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("キャンセル")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn og-btn-purchase",
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.handlePurchase }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "og-spinner" })
                    : _c("span", [
                        _c("span", { staticClass: "og-ticket-icon" }, [
                          _vm._v("🎫")
                        ]),
                        _vm._v(" 特急チケットを購入する")
                      ])
                ]
              )
            ])
          ])
        : _vm.variant === "4"
        ? _c("div", { staticClass: "og-box og4-box" }, [
            _c("div", { staticClass: "og-header og4-header" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "og-close",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "og-body" }, [
              _c("div", { staticClass: "og-product-chip" }, [
                _vm.product.image
                  ? _c("img", {
                      staticClass: "og-product-thumb",
                      attrs: { src: _vm.product.image, alt: "" }
                    })
                  : _c(
                      "div",
                      {
                        staticClass: "og-product-thumb og-product-thumb--empty"
                      },
                      [_vm._v("📦")]
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "og-product-meta" }, [
                  _c("div", { staticClass: "og-product-name" }, [
                    _vm._v(_vm._s(_vm.sliceName(_vm.product.productName)))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "og-product-asin" }, [
                    _vm._v("ASIN: " + _vm._s(_vm.product.asin))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "og-compare" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "og-compare-arrow" }, [
                  _c(
                    "svg",
                    {
                      attrs: { width: "32", height: "32", viewBox: "0 0 32 32" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M8 16h16m0 0l-6-6m6 6l-6 6",
                          stroke: "#008cc6",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(6)
              ]),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "og-price-row og4-price-row" }, [
                _c("div", { staticClass: "og-price-label og4-price-label" }, [
                  _vm._v("特急チケット")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "og-price-amount" }, [
                  _c(
                    "span",
                    { staticClass: "og-price-currency og4-price-text" },
                    [_vm._v("¥")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "og-price-num og4-price-text" }, [
                    _vm._v(_vm._s(_vm.price.toLocaleString()))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "og-price-tax" }, [
                    _vm._v("（税込）")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "og-footer og4-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default og-btn-cancel",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("キャンセル")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn og4-btn-purchase",
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.handlePurchase }
                },
                [
                  _vm.loading
                    ? _c("span", { staticClass: "og-spinner" })
                    : _c("span", [
                        _c("span", { staticClass: "og-ticket-icon" }, [
                          _vm._v("🎫")
                        ]),
                        _vm._v(" 特急チケットを購入する")
                      ])
                ]
              )
            ])
          ])
        : _c("div", { staticClass: "pv-dialog" }, [
            _c(
              "div",
              {
                staticClass: "pv-box",
                class: _vm.variant === "2" ? "pv-box--blue" : "pv-box--orange"
              },
              [
                _c("div", { staticClass: "pv-header" }, [
                  _c(
                    "span",
                    {
                      staticClass: "pv-sparkle pv-sparkle--tl",
                      class:
                        _vm.variant === "2"
                          ? "pv-sparkle--blue"
                          : "pv-sparkle--yellow"
                    },
                    [_vm._v("✦")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "pv-header-icon",
                      class:
                        _vm.variant === "2"
                          ? "pv-icon--blue"
                          : "pv-icon--orange"
                    },
                    [_vm._v("🎫")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pv-header-title-wrap" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "pv-header-underline",
                      class:
                        _vm.variant === "2" ? "pv-ul--blue" : "pv-ul--yellow"
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pv-rows" }, [
                  _c("div", { staticClass: "pv-row" }, [
                    _c("div", { staticClass: "pv-row-icon-wrap" }, [
                      _c("span", { staticClass: "pv-row-emoji" }, [
                        _vm._v("⏰")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pv-sparkle pv-sparkle--icon",
                          class:
                            _vm.variant === "2"
                              ? "pv-sparkle--blue"
                              : "pv-sparkle--yellow"
                        },
                        [_vm._v("✦")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(9)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pv-divider" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "pv-row" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "pv-row-text" }, [
                      _vm._v("\n            特急チケット適用で、"),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pv-accent-text",
                          class:
                            _vm.variant === "2"
                              ? "pv-accent--blue"
                              : "pv-accent--red"
                        },
                        [_c("strong", [_vm._v("3営業日に短縮されます。")])]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "pv-text-underline",
                        class:
                          _vm.variant === "2" ? "pv-ul--blue" : "pv-ul--yellow"
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "pv-sparkle pv-sparkle--row-r",
                        class:
                          _vm.variant === "2"
                            ? "pv-sparkle--blue"
                            : "pv-sparkle--yellow"
                      },
                      [_vm._v("✦")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pv-divider" }),
                  _vm._v(" "),
                  _vm._m(11)
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "pv-callout",
                    class:
                      _vm.variant === "2"
                        ? "pv-callout--blue"
                        : "pv-callout--orange"
                  },
                  [
                    _c("div", { staticClass: "pv-callout-top" }, [
                      _c(
                        "span",
                        {
                          staticClass: "pv-sparkle pv-sparkle--cbl",
                          class:
                            _vm.variant === "2"
                              ? "pv-sparkle--blue"
                              : "pv-sparkle--yellow"
                        },
                        [_vm._v("✦")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pv-callout-icon-wrap",
                          class:
                            _vm.variant === "2"
                              ? "pv-callout-icon--blue"
                              : "pv-callout-icon--orange"
                        },
                        [_vm._v("💰")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pv-callout-text" }, [
                        _vm._v(
                          "\n            ご購入の前に、対象商品をご確認ください。"
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pv-callout-accent",
                            class:
                              _vm.variant === "2"
                                ? "pv-accent--blue"
                                : "pv-accent--red"
                          },
                          [
                            _vm._v(
                              "\n              特急チケット料金：¥" +
                                _vm._s(_vm.price.toLocaleString()) +
                                "（税込）\n            "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pv-sparkle pv-sparkle--cbr",
                          class:
                            _vm.variant === "2"
                              ? "pv-sparkle--blue"
                              : "pv-sparkle--yellow"
                        },
                        [_vm._v("✦")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pv-product-chip" }, [
                      _vm.product.image
                        ? _c("img", {
                            staticClass: "pv-product-thumb",
                            attrs: { src: _vm.product.image, alt: "" }
                          })
                        : _c(
                            "span",
                            {
                              staticClass:
                                "pv-product-thumb pv-product-thumb--empty"
                            },
                            [_vm._v("📦")]
                          ),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "pv-product-name" }, [
                          _vm._v(_vm._s(_vm.sliceName(_vm.product.productName)))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pv-product-asin" }, [
                          _vm._v("ASIN: " + _vm._s(_vm.product.asin))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "pv-callout-underline",
                      class:
                        _vm.variant === "2" ? "pv-ul--blue" : "pv-ul--yellow"
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "pv-cta-btn",
                        class:
                          _vm.variant === "2"
                            ? "pv-cta--blue"
                            : "pv-cta--orange",
                        attrs: { disabled: _vm.loading },
                        on: { click: _vm.handlePurchase }
                      },
                      [
                        _vm.loading
                          ? _c("span", { staticClass: "pv-spinner" })
                          : [
                              _c("span", { staticClass: "pv-cta-icon-left" }, [
                                _vm._v("🎫")
                              ]),
                              _vm._v(
                                "\n            特急チケットを購入する\n            "
                              ),
                              _c("span", { staticClass: "pv-cta-arrow" }, [
                                _vm._v("›")
                              ])
                            ]
                      ],
                      2
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pv-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default pv-close-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("閉じる")]
              )
            ])
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "og-header-left" }, [
      _c("span", { staticClass: "og-badge" }, [_vm._v("特急")]),
      _vm._v(" "),
      _c("h3", { staticClass: "og-title" }, [
        _vm._v("審査を優先的に処理しませんか？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "og-compare-card og-compare-before" }, [
      _c("div", { staticClass: "og-compare-label" }, [
        _vm._v("通常プランの審査期間")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-days" }, [
        _c("span", { staticClass: "og-days-num" }, [_vm._v("20")]),
        _vm._v(" "),
        _c("span", { staticClass: "og-days-unit" }, [_vm._v("日")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-sub" }, [_vm._v("Basicプラン標準")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "og-compare-card og-compare-after" }, [
      _c("div", { staticClass: "og-compare-label" }, [
        _vm._v("特急チケット適用後")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-days" }, [
        _c("span", { staticClass: "og-days-num og-days-fast" }, [_vm._v("3")]),
        _vm._v(" "),
        _c("span", { staticClass: "og-days-unit" }, [_vm._v("営業日")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-sub" }, [
        _vm._v("Premiumプランと同等")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "og-benefits" }, [
      _c("li", [
        _c("span", { staticClass: "og-benefit-icon" }, [_vm._v("⚡")]),
        _vm._v("審査完了まで最大"),
        _c("strong", [_vm._v("17日短縮")]),
        _vm._v("できます")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "og-benefit-icon" }, [_vm._v("🚀")]),
        _vm._v("早期に"),
        _c("strong", [_vm._v("出品開始")]),
        _vm._v("し、販売機会を逃しません")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "og-benefit-icon" }, [_vm._v("✅")]),
        _vm._v("この商品だけに適用 — プラン変更不要")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "og-header-left" }, [
      _c("span", { staticClass: "og-badge og4-badge" }, [_vm._v("特急")]),
      _vm._v(" "),
      _c("h3", { staticClass: "og-title" }, [
        _vm._v("審査を優先的に処理しませんか？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "og-compare-card og-compare-before" }, [
      _c("div", { staticClass: "og-compare-label" }, [
        _vm._v("通常プランの審査期間")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-days" }, [
        _c("span", { staticClass: "og-days-num" }, [_vm._v("20")]),
        _vm._v(" "),
        _c("span", { staticClass: "og-days-unit" }, [_vm._v("日")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-sub" }, [_vm._v("Basicプラン標準")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "og-compare-card og4-compare-after" }, [
      _c("div", { staticClass: "og-compare-label" }, [
        _vm._v("特急チケット適用後")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og-compare-days" }, [
        _c("span", { staticClass: "og-days-num og4-days-fast" }, [_vm._v("3")]),
        _vm._v(" "),
        _c("span", { staticClass: "og-days-unit" }, [_vm._v("営業日")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "og4-compare-sub" }, [
        _vm._v("Premiumプランと同等")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "og-benefits" }, [
      _c("li", [
        _c("span", { staticClass: "og-benefit-icon" }, [_vm._v("⚡")]),
        _vm._v("審査完了まで最大"),
        _c("strong", [_vm._v("17日短縮")]),
        _vm._v("できます")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "og-benefit-icon" }, [_vm._v("🚀")]),
        _vm._v("早期に"),
        _c("strong", [_vm._v("出品開始")]),
        _vm._v("し、販売機会を逃しません")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "og-benefit-icon" }, [_vm._v("✅")]),
        _vm._v("この商品だけに適用 — プラン変更不要")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "pv-header-title" }, [
      _vm._v("審査を優先処理"),
      _c("br"),
      _vm._v("しませんか？")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pv-row-text" }, [
      _vm._v("\n            通常のBasicプランでは"),
      _c("br"),
      _vm._v("\n            審査に"),
      _c("strong", [_vm._v("20日")]),
      _vm._v("かかります。\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pv-row-icon-wrap" }, [
      _c("span", { staticClass: "pv-row-emoji" }, [_vm._v("🚀")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pv-row" }, [
      _c("div", { staticClass: "pv-row-icon-wrap" }, [
        _c("span", { staticClass: "pv-row-emoji" }, [_vm._v("✅")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pv-row-text" }, [
        _vm._v("\n            この商品だけに適用。"),
        _c("br"),
        _vm._v("プラン変更は不要です。\n          ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12ec3e66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12ec3e66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/PriorityReviewModal.vue
// module id = null
// module chunks = 